import {
  TreeOperationResultError,
  TreeOperationResultData,
  TreeOperationResultSuccess,
} from './types'
import { Box, Button } from '@mui/material'
import { downloadJson } from '../../utility'
import React from 'react'
import { BorderedContainer } from '../utility/Containers'
import { Table } from 'shared/ui/Table/Table'
import { Column } from 'shared/ui/Table/types'
import { successCountItems } from './utility'

const errorColumns: Column<TreeOperationResultError>[] = [
  {
    title: 'Type',
    rowContent({ type }: TreeOperationResultError) {
      return type
    },
  },
  {
    title: 'Error',
    rowContent({ value }: TreeOperationResultError) {
      return value
    },
  },
]

export function TreeOperationsResult({
  result,
  flowId,
}: {
  result: TreeOperationResultData
  flowId: string
}) {
  const downloadButton = (
    <Button
      key="download"
      onClick={() =>
        downloadJson('treeOperationResult.json', { flowId, ...result })
      }
    >
      Download Result
    </Button>
  )
  if (result.errors.length) {
    return (
      <BorderedContainer>
        <Table<TreeOperationResultError>
          title={`Errors ${result.errors.length}`}
          columns={errorColumns}
          items={result.errors}
          toolBarItems={[downloadButton]}
        />
        <SuccessCounts result={result.data} />
      </BorderedContainer>
    )
  }
  return (
    <BorderedContainer>
      <Box>All Succeeded: {downloadButton}</Box>
      <SuccessCounts result={result.data} />
    </BorderedContainer>
  )
}

const successColumns: Column<{
  type: string
  method: string
  count: number
}>[] = [
  {
    title: 'Type',
    rowContent({ type }: { type: string }) {
      return type
    },
  },
  {
    title: 'Method',
    rowContent({ method }: { method: string }) {
      return method
    },
  },
  {
    title: 'Count',
    rowContent({ count }: { count: number }) {
      return count
    },
  },
]

function SuccessCounts({ result }: { result: TreeOperationResultSuccess[] }) {
  if (!result.length) return null
  const items = successCountItems(result)
  return (
    <Box>
      <Table
        title={'Success Counts'}
        overrideHeight={180}
        columns={successColumns}
        items={items}
      />
    </Box>
  )
}
